import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import * as Models from 'app/core/models';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';

import { ModalService } from 'app/modal/modal.service';

@Component({
  selector: 'app-confirm-email-modal',
  templateUrl: './emailConfirm.component.html',
  styleUrls: ['./emailConfirm.component.scss']
})

export class EmailConfirmModalComponent implements OnInit, Models.ModalComponent {

  @ViewChild('modalEmailConfirm') public contentModal: any;
  isLoading = false;
  showForm = false;
  showError = false;
  showSuccess = false;
  error: any = null;
  selectedInterests: Models.TagWithCount[] = null;
  selectedSpecialities: Models.TagWithCount[] = null;
  tags: Models.TagWithCount[] = [];
  country: string = null;
  countries: Models.Country[];

  constructor(private authenticationService: AuthenticationService,
              private userService: UserService,
              private router: Router,
              private lookupService: LookupService,
              private modalService: ModalService) {
  }

  ngOnInit() {
    this.isLoading = false;
    this.showForm = false;
    this.showError = false;
    this.error = null;
  }

  openEmailConfirmDialog() {
    this.contentModal.show();
  }

  closeEmailConfirmDialog() {
    this.contentModal.hide();
  }

  closeModal() {
    this.closeEmailConfirmDialog();
  }

  openModal(data: any[]): void {
    this.isLoading = true;
    this.showError = false;
    this.showForm = false;
    this.error = null;

    if (this.authenticationService.isAuthenticated()) {
      this.authenticationService.logoutAction();
    }

    this.openEmailConfirmDialog();

    this.authenticationService.confirmEmail(data[0])
      .finally(() => {
        if (!this.error) {
          this.getUserDetails();
        } else {
          this.isLoading = false;
        }
      })
      .subscribe(credentials => {
        this.authenticationService.setCredentials(credentials, true);
        this.error = null;
      }, error => {
        this.error = error;
        this.authenticationService.setCredentials();
        this.showError = true;
        this.showForm = false;
      });
  }

  saveProfile() {
    this.isLoading = true;
    this.showForm = false;
    const temp: Models.UserDetails = this.userService.userDetails;
    temp.userInterests = this.selectedInterests;
    temp.userSpecialities = this.selectedSpecialities;
    temp.countryId = this.countries.find(x => x.name === this.country).countryId;
    this.userService.saveUserDetails(temp)
      .finally(() => {
        this.isLoading = false;

        this.router.navigate(['/home']);

        const modalData: Models.ModalContext = {
          modalType: Models.ModalType.CONFIRM_EMAIL,
          modalAction: Models.ModalAction.CLOSE,
          parameters: []
        };
        this.modalService.command(modalData);
      })
      .subscribe(userDetails => {
        this.error = null;
        this.userService.setUserDetails(userDetails);
        this.showError = false;
        this.showForm = false;
        this.showSuccess = true;
      }, error => {
        this.error = error;
        this.showError = true;
        this.showForm = false;
      });
  }

  get errorMessage(): string {
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    }
    // @TODO: translate
    return 'There was a problem';
  }

  get countriesString(): string[] {
    return this.countries == null ? [] : this.countries.map(x => x.name);
  }

  get countryId(): number {
    if (!this.country) {
      return null;
    }

    const tempCountry: Models.Country = this.countries.find(x => x.name === this.country);

    if (!tempCountry) {
      return null;
    }

    return tempCountry.countryId;
  }
  private getUserDetails() {
    this.userService.getUserDetails()
      .finally(() => {
        if (!this.error) {
          this.getTags();
        } else {
          this.isLoading = false;
        }
      })
      .subscribe(userDetails => {
        this.error = null;
        this.userService.setUserDetails(userDetails);
        this.showError = false;
      }, error => {
        this.error = error;
        this.authenticationService.setCredentials();
        this.showError = true;
        this.showForm = false;
      });
  }

  private getTags() {
    this.lookupService.getTags(true)
      .finally(() => {
        if (!this.error) {
          this.getCountries();
        } else {
          this.isLoading = false;
        }
      })
      .subscribe(tags => {
          this.tags = tags;
          this.error = null;
          this.showError = false;
        }
        , error => {
          this.error = error;
          this.showError = true;
          this.showForm = false;
        });
  }

  private getCountries() {
    this.lookupService.getCountries()
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(countries => {
          this.countries = countries;
          this.error = null;
          this.showError = false;
          this.showForm = true;
        }
        , error => {
          this.error = error;
          this.showError = true;
          this.showForm = false;
        });
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/emailConfirm/emailConfirm.component.ts